import React, { useState } from "react";
import Input from "../ui/Input";
import Label from "../ui/Label";
import TextArea from "../ui/TextArea";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import ModalButton from "../ui/ModalButton";
import Cookies from "js-cookie";

export default function Debug() {

    const [r, setR] = useState({})
    const [api, setApi] = useState(Cookies.get("debug_api") || "");
    const [params, setParams] = useState(Cookies.get("debug_params") || "");
    const makeCall = () => {
        Cookies.set("debug_api", api)
        Cookies.set("debug_params", params)
        pubCall(api, JSON.parse(params), (_s, _r) => {

            setR(_r)
            if (!_s) {
                showError(_r);
            }
        })
    }


    return (
        <div style={{ "width": "900px" }}>
            <div className="shim" /><div className="shim" />
            <Label style={{ "textAlign": "left" }}>API:</Label>
            <div className="shim" />
            <Input onChange={(e) => setApi(e)} value={api} edit width={500} placeholder="" />
            <div className="shim" /><div className="shim" />

            <Label style={{ "textAlign": "left" }}>Params:</Label>
            <div className="shim" />
            <TextArea onChange={(e) => {

                setParams(e)
            }} value={params} edit height={200} width={500} placeholder="" />
            <ModalButton onClick={() => makeCall()} style={{ "backgroundColor": "#111", "width": "50px", "textAlign": "center", "padding": "3px 10px" }} value={<small>TEST</small>} />
            <div className="shim" /><div className="shim" />
            <Label style={{ "textAlign": "left" }}>Results:</Label>
            <div style={{ "height": "300px", "overflow": "scroll", "color": "#eee" }}>
                <pre><small> {JSON.stringify(r, null, 2)}</small></pre>
            </div>
        </div>
    )
}